module.exports = __webpack_public_path__ + "static/media/pt2.481e456c.svg";